// UTM capture: persist for the session so all form submissions carry attribution.
const STORAGE_KEY = "asahni_utm";
const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];

function getStored() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

function setStored(obj) {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(obj));
  } catch {}
}

/** Call once on app mount. Captures UTM + referrer on first landing only. */
export function captureUTM() {
  if (typeof window === "undefined") return null;
  const existing = getStored();
  if (existing) return existing;

  const params = new URLSearchParams(window.location.search);
  const utm = {
    source: params.get("utm_source") || null,
    medium: params.get("utm_medium") || null,
    campaign: params.get("utm_campaign") || null,
    content: params.get("utm_content") || null,
    term: params.get("utm_term") || null,
    referrer: document.referrer || null,
    landing_page: window.location.pathname + window.location.search || null,
  };

  // Only persist if at least one UTM or referrer is present, otherwise mark as direct
  const hasAttribution = UTM_KEYS.some((k) => params.get(k)) || !!document.referrer;
  if (hasAttribution || true) {
    // Always persist landing/referrer for traffic-source visibility
    setStored(utm);
  }
  return utm;
}

/** Returns the UTM object for attaching to API payloads. May be null. */
export function getUTM() {
  return getStored();
}
